<template>
  <div>
    <b-modal :id="`bv-modal-edit-address`" size="lg" hide-footer>
      <template #modal-title>Edit address</template>

      <div class="row">
        <div class="col">
            <label class="form-label pt-2 mb-2">Receiver Name</label>
            <input class="form-control2" v-model="address.receiver_name">
        </div>
        <div class="col">
            <label class="form-label pt-2 mb-2">Receiver Phone</label>
            <input class="form-control2" v-model="address.receiver_phone">
        </div>
      </div>

      <div class="row">
        <div class="col">
            <label class="form-label pt-2 mb-2">Building Name <small>(Optional)</small></label>
            <input class="form-control2" v-model="address.building">
        </div>
        <div class="col">
            <label class="form-label pt-2 mb-2">Unit Number <small>(optional)</small></label>
            <input class="form-control2" v-model="address.unit_number">
        </div>
      </div>

      <div class="row">
        <div class="col">
            <label class="form-label pt-2 mb-2">Street Address</label>
            <input class="form-control2" v-model="address.street_address">
        </div>
      </div>

      <div class="row">
         <div class="col">
            <label class="form-label pt-2 mb-2">Suburb</label>
            <input class="form-control2" v-model="address.suburb">
        </div>
        <div class="col">
            <label class="form-label pt-2 mb-2">Postal Code</label>
            <input class="form-control2" v-model="address.postal_code">
        </div>
      </div>

      <div class="row">
        <div class="col">
            <label class="form-label pt-2 mb-2">City</label>
            <input class="form-control2" v-model="address.city">
        </div>
        <div class="col">
            <label class="form-label pt-2 mb-2">Province</label>
            <select class="form-control2" v-model="address.province">
                <option value="Eastern Cape">Eastern Cape</option>
                <option value="Free State">Free State</option>
                <option value="Gauteng">Gauteng</option>
                <option value="KwaZulu-Natal">KwaZulu-Natal</option>
                <option value="Limpopo">Limpopo</option>
                <option value="Mpumalanga">Mpumalanga</option>
                <option value="North West">North West</option>
                <option value="Northern Cape">Northern Cape</option>
                <option value="Western Cape">Western Cape</option>
            </select>
        </div>
      </div>

      <div class="row">
        <div class="col">
            <label class="form-label pt-2 mb-2">Country</label>
            <select class="form-control2" v-model="address.country">
                <option value="ZA">South Africa</option>
            </select>
        </div>
        <div class="col">
            <label class="form-label pt-2 mb-2">Business Name <small>(Optional)</small></label>
            <input class="form-control2" v-model="address.business_name">
        </div>
      </div>

      <div class="row mt-3 pb-2">
        <div class="col">
                  <div>
<button v-if="updating" type="button" class="btn btn-success submit col">
  <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
        <button v-else type="button" class="btn btn-danger submit col" @click="saveAddress">Save Address</button>
      </div>
        </div>
      </div>

    </b-modal>
  </div>
</template> 

<script>
import { EventBus } from '../bus';

export default {
  props: ['address'],

  data() {
    return {
      updating: false,
    };
  },

  methods: {

    hideModalEditAddress() {
      this.$bvModal.hide('bv-modal-edit-address');
    },

            saveAddress() {

              if (!this.address.receiver_name) { this.sweetfire('Please enter receiver name')}
              else if (!this.address.receiver_phone) { this.sweetfire('Please enter receiver phone')}

            else {

              this.updating = true;

              axios.post('/address/update', {address: this.address})
                .then((response) => {

                if (response.data.success) {
                    EventBus.$emit('get-my-addressses');
                    this.hideModalEditAddress();
                } else {
                    this.sweetfire(response.data.message);
                }

                this.updating = false;

                });

          }

      },

      sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: { title: "popup-title" },
    })

    },
  },
};
</script>

<style scoped>
textarea.form-control { font-size: 0.9rem !important; }
</style>